import { BreeceSelectorDetails } from "../models/breece-selector-details.model";
import { IBreeceSelectorDetailsResponse } from "../response/breece-selector-details.response";
import { IBreeceSelectorsResponse } from "../response/breece-selectors.response";

export const mapBreeceSelectors = (from: IBreeceSelectorsResponse, enumName: string) : BreeceSelectorDetails[] => {
    return from.enumValues.map((enumDetail) => mapBreeceSelectorDetails(enumDetail, enumName));

}

export const mapBreeceSelectorDetails = (from: IBreeceSelectorDetailsResponse, enumName: string) : BreeceSelectorDetails => {
    let result = new BreeceSelectorDetails();
    result.enumName = enumName;
    result.description = from.description;
    result.translation = from.translation;
    result.translationCode = from.translationCode;
    result.value = from.value;
    return result;
}
